export const locale = {
  lang: 'es',
  data: {
    'My Profile': 'Mi Perfil',
    'Logout': 'Salir'
  }
};
